export default __webpack_public_path__ + "static/88957-862752de645dd98d3a911859ed32852f.jpg";